import styles from "./LicenseFilter.module.css"
import CustomRadio from "@/components/UI/Buttons/Radio/CustomRadio";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

function parseLicenseValue(str: string): string {
    if (!str) return '';
    const match = str.match(/license=([^&]+)/);
    return match ? match[1] : '';
}

export default function LicenseFilter({ update, resetSignal, initialData }: {
    update: (name: string, value: string) => void,
    resetSignal: number,
    initialData: string}) {

    const [license, setLicense] = useState(parseLicenseValue(initialData))
    const t = useTranslations("Catalogue")
    
    useEffect(() => {
        if(license !== '') update('license', 'license=' + license)
        else update('license','')
    }, [license])

    function handleChange(newLicense:string) {
        if(license === newLicense) setLicense('')
        else setLicense(newLicense)
    }

    useEffect(() => {
        setLicense('')
    }, [resetSignal])

    useEffect(() => {
        setLicense(parseLicenseValue(initialData))
    }, [])

    return (
        <div data-testid="LicenseFilter">
            <h4 className={`bodyTextMedium ${styles.title}`} data-testid="LicenseFilter_title">{t('licensesTitle')}</h4>
            <div className={styles.filters}>
                <CustomRadio label={'Battle.net'} id='Battle.net' name='license' onChange={() => handleChange('battlenet')} checked={license === 'battlenet'} />
                <CustomRadio label={'Steam'} id='Steam' name='license' onChange={() => handleChange('steam')} checked={license === 'steam'}/>
                <CustomRadio label={'Epic'} id='Epic' name='license' onChange={() => handleChange('epic')} checked={license === 'epic'}/>
            </div>
        </div>
    )
}